<template>
  <div class="content">
    <h1>Terms and Conditions</h1>
    <p><strong>Last updated:</strong> 2025-06-11</p>

    <h3>1. Introduction</h3>
    <p>Welcome to <strong>Take Away Near Me (TANM)</strong>. By accessing or using our website, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use the platform.</p>

    <h3>2. Our Service</h3>
    <p>TANM connects customers with local takeaway and delivery vendors. We act as an intermediary; the contract for food preparation and delivery is between you and the vendor.</p>

    <h3>3. Ordering</h3>
    <p>Orders placed through TANM are sent to the vendor. You are responsible for checking item details, dietary information, and prices before confirming.</p>

    <h3>4. Payment</h3>
    <p>Payments are securely processed via <strong>Stripe</strong>. TANM never stores your card details. Prices include VAT where applicable.</p>

    <h3>5. Cancellations & Refunds</h3>
    <p>Once an order is accepted by the vendor, cancellation may not be possible. If you encounter an issue, contact support at <a href="mailto:support@tanm.co.uk">support@tanm.co.uk</a>.</p>

    <h3>6. User Conduct</h3>
    <ul>
      <li>Submitting false orders</li>
      <li>Abusive behavior toward staff or vendors</li>
      <li>Attempting to reverse engineer the platform</li>
    </ul>

    <h3>7. Account Termination</h3>
    <p>We may suspend or terminate access to our platform if you violate these terms or applicable laws.</p>

    <h3>8. Liability</h3>
    <p>TANM is not liable for:</p>
    <ul>
      <li>Food quality or allergens</li>
      <li>Delays or failures caused by vendors</li>
      <li>Indirect or consequential losses</li>
    </ul>

    <h3>9. Changes to Terms</h3>
    <p>We may update these terms. Continued use of the service implies acceptance of the changes.</p>
  </div>
</template>
